// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"OrderRatingStars-93636ec20df90934","label":"OrderRatingStars-e1c46fd91257e362","input":"OrderRatingStars-cfe48b3a5a2f01db"};